import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconComponent } from '@reforgium/icon';
import { LangPipe } from '@reforgium/presentia';

import { urls } from 'constants/urls.constant';

@Component({
  selector: 'app-tax-code-shortcut',
  imports: [RouterLink, IconComponent, LangPipe],
  template: `
    <a class="tax-code-shortcut" [routerLink]="documentLink.path" [queryParams]="documentLink.queryParams">
      <span class="tax-code-title">{{ 'document.tax-code.title' | lang }}</span>
      <re-icon class="tax-code-chevron" name="chevron" width="12" height="12" aria-hidden="true" />
    </a>
  `,
  styles: `
    :host {
      display: block;
      margin-top: 12px;
    }
    .tax-code-shortcut {
      position: relative;
      display: flex;
      align-items: center;
      gap: 8px;
      width: fit-content;
      max-width: 100%;
      min-height: 48px;
      padding: 14px 16px;
      border: 1px solid color-mix(in srgb, var(--primary-color) 30%, var(--border-color));
      border-radius: 16px;
      background: var(--secondary-light);
      color: var(--primary-light);
      font-size: calc(14px * var(--a11y-font-scale, 1));
      font-weight: 600;
      line-height: 1.4;
      text-decoration: none;
      box-shadow: 0 6px 4px 0 #00000010;
      transition:
        background-color 150ms,
        border-color 150ms,
        box-shadow 150ms;
    }
    @media (hover: hover) {
      .tax-code-shortcut:hover {
        background: color-mix(in srgb, var(--secondary-light) 85%, var(--text-primary));
        border-color: var(--secondary-light);
        box-shadow: 0 6px 10px 0 #00000018;
      }
    }
    .tax-code-shortcut:focus-visible {
      outline: 2px solid var(--text-primary);
      outline-offset: 3px;
    }
    .tax-code-shortcut:active {
      background: color-mix(in srgb, var(--secondary-light) 75%, var(--text-primary));
      box-shadow: 0 2px 3px 0 #00000010;
    }
    .tax-code-title {
      min-width: 0;
      overflow-wrap: anywhere;
    }
    .tax-code-chevron {
      flex: 0 0 12px;
    }
    @media (prefers-reduced-motion: reduce) {
      .tax-code-shortcut {
        transition: none;
      }
    }
  `,
})
export class TaxCodeShortcutComponent {
  // Temporary document reference: keep the route and revision together until a stable link is available.
  protected readonly documentLink = {
    path: '/' + urls.document(29),
    queryParams: { versionId: 299, categoryId: 21 },
  };
}
